import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Link from '../../AppLink';

import CheckIcon from '../../../icons/done.svg';

// Router
import { getRoute } from '../../../entry/routes';

import styles from './CheckItem.styl';

const cx = classNames.bind(styles);

export default function CheckItem(props) {
  const { criteria, check, goods, code, idx, isOutOfStock } = props;

  const hasGoods = goods.length > 0;
  const Component = hasGoods && !isOutOfStock ? Link : 'div';
  const to = goods ? getRoute('stockConditions', idx, code) : getRoute('home');

  return (
    <Component
      to={to}
      className={cx('CheckItem', {
        CheckItem_checked: check && !isOutOfStock,
        CheckItem_outOfStock: isOutOfStock,
      })}
    >
      <div className={cx('CheckItem__criteria')}>
        <CheckIcon className={cx('CheckItem__icon', { CheckItem_outOfStock: isOutOfStock })} />
        {criteria}
      </div>
    </Component>
  );
}

CheckItem.defaultProps = {
  goods: [],
  isOutOfStock: false,
};

CheckItem.propTypes = {
  criteria: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  goods: PropTypes.array,
  code: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  isOutOfStock: PropTypes.bool,
};
